export const BUTTON_VARIANTS = {
  SOLID: 'solid',
  SUBTLE: 'subtle',
  OUTLINE: 'outline',
  GHOST: 'ghost',
};
